import { forwardRef } from 'react';

export const Account = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(function Icon(
  props,
  ref,
) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M6.903 7.274c0-3.184 2.578-5.774 5.75-5.774s5.749 2.589 5.749 5.774a5.78 5.78 0 0 1-3.39 5.265 9.97 9.97 0 0 1 7.474 8.402 1.39 1.39 0 0 1-.334 1.093c-.262.296-.637.466-1.031.466H4.187a1.38 1.38 0 0 1-1.036-.471 1.39 1.39 0 0 1-.33-1.087c.527-4.117 3.535-7.435 7.477-8.401-2-.905-3.395-2.925-3.395-5.267zm5.75 3.858c2.117 0 3.841-1.731 3.841-3.858s-1.724-3.858-3.841-3.858-3.841 1.732-3.841 3.858 1.724 3.858 3.841 3.858zm0 3.031c-3.769 0-7.314 2.922-7.668 6.339h15.281c-.349-3.424-3.855-6.339-7.613-6.339z"
        fill="currentColor"
      />
    </svg>
  );
});
